if (typeof McCatalogBanner === 'undefined') {
  class McCatalogBanner {
    constructor() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }

      this.watchCatalogUpdate();
    }

    getCatalogPage() {
      return document.querySelector('#catalogPage');
    }

    getCatalogGrid() {
      const catalogPage = this.getCatalogPage();

      if (!catalogPage) {
        return null;
      }

      return (
        catalogPage.querySelector('.collection-products') ||
        catalogPage.querySelector('#Collection') ||
        catalogPage
      );
    }

    getBanner() {
      const catalogPage = this.getCatalogPage();
      const bannerInCatalog = catalogPage
        ? catalogPage.querySelector('.mc-catalog-banner-wrapper')
        : null;

      return bannerInCatalog || document.querySelector('.mc-catalog-banner-wrapper');
    }

    initSlider() {
      const sliderRoot = this.banner
        ? this.banner.querySelector('.mc-catalog-banner')
        : null;

      if (!sliderRoot || sliderRoot.dataset.sliderInitialized === 'true') {
        return;
      }

      const slides = Array.from(
        sliderRoot.querySelectorAll('.mc-catalog-banner__slide')
      );
      const dots = Array.from(
        sliderRoot.querySelectorAll('.mc-catalog-banner__dot')
      );

      if (!slides.length || !dots.length) {
        return;
      }

      const INTERVAL = 15000;
      let current = slides.findIndex((slide) =>
        slide.classList.contains('is-active')
      );
      let timer;

      if (current < 0) {
        current = 0;
      }

      const getFocusable = (slide) =>
        Array.from(
          slide.querySelectorAll(
            'a[href], button, input:not([type="hidden"]), select, textarea, audio[controls], video[controls], summary, [contenteditable]:not([contenteditable="false"]), [tabindex]'
          )
        );

      const setSlideA11y = (slide, isActive) => {
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.toggleAttribute('inert', !isActive);

        getFocusable(slide).forEach((element) => {
          if (isActive) {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', '-1');
          }
        });
      };

      const goTo = (index) => {
        slides[current].classList.remove('is-active');
        setSlideA11y(slides[current], false);
        dots[current].classList.remove('is-active');

        current = (index + slides.length) % slides.length;

        slides[current].classList.add('is-active');
        setSlideA11y(slides[current], true);
        dots[current].classList.add('is-active');
      };

      const start = () => {
        timer = window.setInterval(() => goTo(current + 1), INTERVAL);
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          window.clearInterval(timer);
          goTo(index);
          start();
        });
      });

      slides.forEach((slide, index) => {
        setSlideA11y(slide, index === current);
      });

      sliderRoot.dataset.sliderInitialized = 'true';
      start();
    }

    getCardOffset() {
      const width = window.innerWidth;

      if (width >= 1100 && width <= 1199) {
        return 5;
      }

      return 7;
    }

    init() {
      const catalogGrid = this.getCatalogGrid();
      this.banner = this.getBanner();
      const cardOffset = this.getCardOffset();

      if (!catalogGrid) {
        return;
      }

      if (!this.banner) {
        return;
      }

      const productCards = catalogGrid.querySelectorAll('.product-card');

      if (!productCards.length) {
        return;
      }

      this.initSlider();

      const targetCard =
        productCards.length <= cardOffset
          ? productCards[productCards.length - 1]
          : productCards[cardOffset];
      const targetContainer =
        targetCard.closest('.collection-products, #Collection') ||
        targetCard.parentNode ||
        catalogGrid;

      if (targetCard.nextSibling) {
        targetCard.parentNode.insertBefore(this.banner, targetCard.nextSibling);
      } else {
        targetContainer.appendChild(this.banner);
      }

      this.banner.style.display = '';
    }

    watchCatalogUpdate() {
      document.addEventListener('filtersUpdated', () => {
        this.init();
      });
    }
  }

  new McCatalogBanner();
}
